import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import contact50a660 from './contact'
/**
* @see \App\Http\Controllers\Shop\PageController::contact
* @see app/Http/Controllers/Shop/PageController.php:24
* @route '/contact'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: '/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PageController::contact
* @see app/Http/Controllers/Shop/PageController.php:24
* @route '/contact'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PageController::contact
* @see app/Http/Controllers/Shop/PageController.php:24
* @route '/contact'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::contact
* @see app/Http/Controllers/Shop/PageController.php:24
* @route '/contact'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PageController::contact
* @see app/Http/Controllers/Shop/PageController.php:24
* @route '/contact'
*/
const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::contact
* @see app/Http/Controllers/Shop/PageController.php:24
* @route '/contact'
*/
contactForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::contact
* @see app/Http/Controllers/Shop/PageController.php:24
* @route '/contact'
*/
contactForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contact.form = contactForm

/**
* @see \App\Http\Controllers\Shop\PageController::shipping
* @see app/Http/Controllers/Shop/PageController.php:61
* @route '/shipping'
*/
export const shipping = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: shipping.url(options),
    method: 'get',
})

shipping.definition = {
    methods: ["get","head"],
    url: '/shipping',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PageController::shipping
* @see app/Http/Controllers/Shop/PageController.php:61
* @route '/shipping'
*/
shipping.url = (options?: RouteQueryOptions) => {
    return shipping.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PageController::shipping
* @see app/Http/Controllers/Shop/PageController.php:61
* @route '/shipping'
*/
shipping.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: shipping.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::shipping
* @see app/Http/Controllers/Shop/PageController.php:61
* @route '/shipping'
*/
shipping.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: shipping.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PageController::shipping
* @see app/Http/Controllers/Shop/PageController.php:61
* @route '/shipping'
*/
const shippingForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: shipping.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::shipping
* @see app/Http/Controllers/Shop/PageController.php:61
* @route '/shipping'
*/
shippingForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: shipping.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::shipping
* @see app/Http/Controllers/Shop/PageController.php:61
* @route '/shipping'
*/
shippingForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: shipping.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

shipping.form = shippingForm

/**
* @see \App\Http\Controllers\Shop\PageController::returns
* @see app/Http/Controllers/Shop/PageController.php:69
* @route '/returns'
*/
export const returns = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returns.url(options),
    method: 'get',
})

returns.definition = {
    methods: ["get","head"],
    url: '/returns',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PageController::returns
* @see app/Http/Controllers/Shop/PageController.php:69
* @route '/returns'
*/
returns.url = (options?: RouteQueryOptions) => {
    return returns.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PageController::returns
* @see app/Http/Controllers/Shop/PageController.php:69
* @route '/returns'
*/
returns.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returns.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::returns
* @see app/Http/Controllers/Shop/PageController.php:69
* @route '/returns'
*/
returns.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: returns.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PageController::returns
* @see app/Http/Controllers/Shop/PageController.php:69
* @route '/returns'
*/
const returnsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returns.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::returns
* @see app/Http/Controllers/Shop/PageController.php:69
* @route '/returns'
*/
returnsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returns.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::returns
* @see app/Http/Controllers/Shop/PageController.php:69
* @route '/returns'
*/
returnsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returns.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

returns.form = returnsForm

/**
* @see \App\Http\Controllers\Shop\PageController::privacy
* @see app/Http/Controllers/Shop/PageController.php:77
* @route '/privacy'
*/
export const privacy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

privacy.definition = {
    methods: ["get","head"],
    url: '/privacy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PageController::privacy
* @see app/Http/Controllers/Shop/PageController.php:77
* @route '/privacy'
*/
privacy.url = (options?: RouteQueryOptions) => {
    return privacy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PageController::privacy
* @see app/Http/Controllers/Shop/PageController.php:77
* @route '/privacy'
*/
privacy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::privacy
* @see app/Http/Controllers/Shop/PageController.php:77
* @route '/privacy'
*/
privacy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacy.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PageController::privacy
* @see app/Http/Controllers/Shop/PageController.php:77
* @route '/privacy'
*/
const privacyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::privacy
* @see app/Http/Controllers/Shop/PageController.php:77
* @route '/privacy'
*/
privacyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::privacy
* @see app/Http/Controllers/Shop/PageController.php:77
* @route '/privacy'
*/
privacyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

privacy.form = privacyForm

/**
* @see \App\Http\Controllers\Shop\PageController::terms
* @see app/Http/Controllers/Shop/PageController.php:85
* @route '/terms'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: '/terms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PageController::terms
* @see app/Http/Controllers/Shop/PageController.php:85
* @route '/terms'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PageController::terms
* @see app/Http/Controllers/Shop/PageController.php:85
* @route '/terms'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::terms
* @see app/Http/Controllers/Shop/PageController.php:85
* @route '/terms'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PageController::terms
* @see app/Http/Controllers/Shop/PageController.php:85
* @route '/terms'
*/
const termsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::terms
* @see app/Http/Controllers/Shop/PageController.php:85
* @route '/terms'
*/
termsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::terms
* @see app/Http/Controllers/Shop/PageController.php:85
* @route '/terms'
*/
termsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

terms.form = termsForm

/**
* @see \App\Http\Controllers\Shop\PageController::cookies
* @see app/Http/Controllers/Shop/PageController.php:93
* @route '/cookies'
*/
export const cookies = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

cookies.definition = {
    methods: ["get","head"],
    url: '/cookies',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PageController::cookies
* @see app/Http/Controllers/Shop/PageController.php:93
* @route '/cookies'
*/
cookies.url = (options?: RouteQueryOptions) => {
    return cookies.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PageController::cookies
* @see app/Http/Controllers/Shop/PageController.php:93
* @route '/cookies'
*/
cookies.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::cookies
* @see app/Http/Controllers/Shop/PageController.php:93
* @route '/cookies'
*/
cookies.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cookies.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PageController::cookies
* @see app/Http/Controllers/Shop/PageController.php:93
* @route '/cookies'
*/
const cookiesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::cookies
* @see app/Http/Controllers/Shop/PageController.php:93
* @route '/cookies'
*/
cookiesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::cookies
* @see app/Http/Controllers/Shop/PageController.php:93
* @route '/cookies'
*/
cookiesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookies.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cookies.form = cookiesForm

/**
* @see \App\Http\Controllers\Shop\PageController::sellCollection
* @see app/Http/Controllers/Shop/PageController.php:101
* @route '/vinde-colectia-pokemon'
*/
export const sellCollection = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sellCollection.url(options),
    method: 'get',
})

sellCollection.definition = {
    methods: ["get","head"],
    url: '/vinde-colectia-pokemon',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PageController::sellCollection
* @see app/Http/Controllers/Shop/PageController.php:101
* @route '/vinde-colectia-pokemon'
*/
sellCollection.url = (options?: RouteQueryOptions) => {
    return sellCollection.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PageController::sellCollection
* @see app/Http/Controllers/Shop/PageController.php:101
* @route '/vinde-colectia-pokemon'
*/
sellCollection.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sellCollection.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::sellCollection
* @see app/Http/Controllers/Shop/PageController.php:101
* @route '/vinde-colectia-pokemon'
*/
sellCollection.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sellCollection.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PageController::sellCollection
* @see app/Http/Controllers/Shop/PageController.php:101
* @route '/vinde-colectia-pokemon'
*/
const sellCollectionForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sellCollection.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::sellCollection
* @see app/Http/Controllers/Shop/PageController.php:101
* @route '/vinde-colectia-pokemon'
*/
sellCollectionForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sellCollection.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PageController::sellCollection
* @see app/Http/Controllers/Shop/PageController.php:101
* @route '/vinde-colectia-pokemon'
*/
sellCollectionForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sellCollection.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sellCollection.form = sellCollectionForm

const pages = {
    contact: Object.assign(contact, contact50a660),
    shipping: Object.assign(shipping, shipping),
    returns: Object.assign(returns, returns),
    privacy: Object.assign(privacy, privacy),
    terms: Object.assign(terms, terms),
    cookies: Object.assign(cookies, cookies),
    sellCollection: Object.assign(sellCollection, sellCollection),
}

export default pages